'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getLiveCasinoV2 = exports.getLiveCasino = exports.getTopGamesUWC = exports.getTopGamesWager = exports.getTopGames = exports.getJackpots = exports.getRecentSignIns = exports.getRecentSignUps = exports.getRecentWinById = exports.getRecentWins = exports.getRecentGames = exports.getRecentDeposits = undefined;

var _utils = require('./utils');

var getRecentDeposits = exports.getRecentDeposits = function getRecentDeposits(limit) {
  return (0, _utils.get)('/event-feed/recent-deposits?limit=' + limit);
};

var getRecentGames = exports.getRecentGames = function getRecentGames() {
  var limit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 10;
  return (0, _utils.get)('/event-feed/recent-games?limit=' + limit);
};

var getRecentWins = exports.getRecentWins = function getRecentWins() {
  var limit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 10;
  var threshold = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 10;
  return (0, _utils.get)('/event-feed/recent-wins?limit=' + limit + '&threshold=' + threshold);
};

var getRecentWinById = exports.getRecentWinById = function getRecentWinById(gameId) {
  var limit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 10;
  var threshold = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 10;
  return (0, _utils.get)('/event-feed/recent-wins/' + gameId + '?limit=' + limit + '&threshold=' + threshold);
};

var getRecentSignUps = exports.getRecentSignUps = function getRecentSignUps() {
  var limit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 10;
  return (0, _utils.get)('/event-feed/recent-signups?limit=' + limit);
};

var getRecentSignIns = exports.getRecentSignIns = function getRecentSignIns() {
  var limit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 10;
  return (0, _utils.get)('/event-feed/recent-signins?limit=' + limit);
};

var getJackpots = exports.getJackpots = function getJackpots(currency) {
  return (0, _utils.get)('/event-feed/jackpots?currency=' + currency);
};

var getTopGames = exports.getTopGames = function getTopGames() {
  var limit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 50;
  return (0, _utils.get)('/event-feed/top-games/' + limit);
};

var getTopGamesWager = exports.getTopGamesWager = function getTopGamesWager() {
  var limit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 50;
  return (0, _utils.get)('/event-feed/top-games-wager/' + limit);
};

var getTopGamesUWC = exports.getTopGamesUWC = function getTopGamesUWC() {
  var limit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 50;
  return (0, _utils.get)('/event-feed/top-games-uwc/' + limit);
};

var getLiveCasino = exports.getLiveCasino = function getLiveCasino() {
  var gameIds = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var tableIds = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  var query = '';

  if (gameIds) query += 'gameIds=' + gameIds;

  if (tableIds) query += gameIds ? '&tableIds=' + tableIds : 'tableIds=' + tableIds;

  return (0, _utils.get)('/event-feed/live-casino-lobby?' + query);
};

var getLiveCasinoV2 = exports.getLiveCasinoV2 = function getLiveCasinoV2(data) {
  return (0, _utils.post)('/event-feed/live-casino-lobby/v2', data);
};

exports.default = {
  getRecentDeposits: getRecentDeposits,
  getRecentGames: getRecentGames,
  getRecentWins: getRecentWins,
  getRecentWinById: getRecentWinById,
  getRecentSignUps: getRecentSignUps,
  getRecentSignIns: getRecentSignIns,
  getJackpots: getJackpots,
  getTopGames: getTopGames,
  getTopGamesWager: getTopGamesWager,
  getTopGamesUWC: getTopGamesUWC,
  getLiveCasino: getLiveCasino,
  getLiveCasinoV2: getLiveCasinoV2
};